import { PropsWithChildren } from 'react';

import ChannelProvider from '@/channels/ChannelProvider';
import { profileAiChatChannelName } from '@/channels/utils/channelNames';

import { Props } from './types';

const AIProfileChatChannel = ({ children, personId, userId }: PropsWithChildren<Props>) => {
  return (
    <ChannelProvider channelName={profileAiChatChannelName(personId, userId)}>
      {children}
    </ChannelProvider>
  );
};

export default AIProfileChatChannel;
